<template>
  <Layout>
    <b-row class="pb-4 pt-2">
      <b-col md="5">
        <Button location="title" type="white" @click="handleCancel()">
          Voltar
        </Button>
      </b-col>
      <b-col md="3">
        <h1 class="title">
          {{ this.cfopParameterization.id ? 'Editar' : 'Nova' }} Parametrização
        </h1>
      </b-col>
    </b-row>
    <Form>
      <Tabs :menus="panelMenus">
        <template v-slot:0>
          <div>
            <b-row>
              <b-col md="6">
                <SelectCfop
                  id="originCfop"
                  label="CFOP de Origem"
                  labelBold
                  v-model="cfopParameterization.origin"
                  :type="2"
                  :error="$v.cfopParameterization.origin.$error"
                />
              </b-col>
              <b-col md="6">
                <SelectCfop
                  id="conversionCfop"
                  label="CFOP de Conversão"
                  labelBold
                  v-model="cfopParameterization.conversion"
                  :type="1"
                  :error="$v.cfopParameterization.conversion.$error"
                />
              </b-col>
            </b-row>
          </div>
        </template>
      </Tabs>
      <FooterForm @cancel="handleCancel" @submit="save" />
    </Form>
  </Layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required, getIdByLastSlash } from '@/reusable';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import {
  Tabs,
  Form,
  Layout,
  Button,
  SelectCfop,
  FooterForm,
} from '@/components';

export default {
  name: 'CfopParameterizationForm',
  mixins: [FormatMixin],
  components: {
    Form,
    Tabs,
    Layout,
    Button,
    FooterForm,
    SelectCfop,
  },
  validations: {
    cfopParameterization: {
      origin: {
        id: { required },
      },
      conversion: {
        id: { required },
      },
    },
  },
  data() {
    return {
      panelMenus: [{ id: 0, label: 'Geral' }],
    };
  },
  async mounted() {
    this.setLoading(true);
    const id = getIdByLastSlash(this.$route.fullPath);

    if (!id) return this.setLoading(false);

    try {
      await this.setDetailedCfopParameterization(id);
    } catch (error) {
      this.$router.push({ name: 'CfopParameterizationRegister' });
    }

    return this.setLoading(false);
  },
  computed: {
    ...mapState('cfopParameterizations', ['cfopParameterization']),
  },
  methods: {
    ...mapActions('cfopParameterizations', [
      'saveCfopParameterization',
      'setDetailedCfopParameterization',
    ]),
    ...mapActions('application', ['setLoading']),
    async save() {
      this.$v.cfopParameterization.$touch();
      if (this.$v.cfopParameterization?.$error) return;

      try {
        await this.saveCfopParameterization(this.cfopParameterization);
        this.handleCancel();
      } finally {
        this.setLoading(false);
      }
    },
    handleCancel() {
      this.$router.push({ name: 'CfopParameterization' });
    },
  },
};
</script>
